var _polygon, _polygon2, _rect, _polygon3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlickLogo2021(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1030.14 326.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "242.14 224.66 419.04 224.66 419.04 161.82 315.67 161.82 315.67 4.71 242.14 4.71 242.14 224.66"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "943.1 4.71 880.57 87.04 880.57 4.71 807.05 4.71 807.05 224.66 880.57 224.66 880.57 177.85 899.42 154.91 942.47 224.66 1030.14 224.66 951.9 100.23 1028.57 4.71 943.1 4.71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 451.63,
    y: 4.71,
    width: 73.53,
    height: 219.95
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 4.71 0 131.81 24.36 131.81 24.36 224.72 48.72 224.72 48.72 326.29 129.28 201.72 98.92 201.72 98.92 152.75 201.69 152.75 201.69 95.55 98.92 95.55 98.92 67.57 209.55 67.57 209.55 4.71 0 4.71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M753.91,319.81c54.67,0,85.47-26.71,104-59.39l-60.65-34.25c-9.11,16.34-20.74,27.65-41.47,27.65-24.2,0-41.17-20.11-41.17-48.7v-.63c0-26.4,16.34-48.08,41.17-48.08,20.11,0,31.73,11,39.9,26.71l60.64-35.5c-18.53-33.62-51.21-57.19-99.6-57.19-65.67,0-116.89,49-116.89,114.69v.63c0,68.18,53.1,114.06,114.06,114.06",
    transform: "translate(-83.86 -90.43)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlickLogo2021);
export default __webpack_public_path__ + "static/media/flick_logo_2021.138d20941fa6b10255dad06d51c72d1b.svg";
export { ForwardRef as ReactComponent };